import { render, staticRenderFns } from "./BatchResultsPage.vue?vue&type=template&id=771c8ed7&scoped=true"
import script from "./BatchResultsPage.vue?vue&type=script&lang=js"
export * from "./BatchResultsPage.vue?vue&type=script&lang=js"
import style0 from "./BatchResultsPage.vue?vue&type=style&index=0&id=771c8ed7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771c8ed7",
  null
  
)

export default component.exports